import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { IkaPersonelService } from '../ctl-ika-personel.service';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private service: IkaPersonelService) {}

    getData(control: any, customQuery?: string) {
        let tableName = control.dlistMetadata.baseEntity;
        let query = ""; 
        if(customQuery?.length > 0){
          query = query + "search=" + customQuery;
        }
        if(this.service.isActivePersonel){
            if(query.length > 0 ) query = query + "&";
            query = query + "AktifEh=E"
        } 
        if(this.service.rolAd?.length > 0){
            if(query.length > 0 ) query = query + "&";
            query = query + "RolAd=" + this.service.rolAd;
            } 
        if(this.service.isActiveDate.length > 0){
        if(query.length > 0 ) query = query + "&";
        query = query + "AktifTarih=" + this.service.isActiveDate;
        } 
        if (this.service.customQuery?.length > 0) {

            let customQuery = this.service.customQuery;

            if (query.length > 0) {
                if (customQuery.startsWith('?')) {
                customQuery = customQuery.substring(1);
                }
                query = query + "&";
            }

            query = query + customQuery;
        }
        if(query.length > 0){
            
                if (query.startsWith('?')) {
                query = query.substring(1);
                }
                tableName = tableName + "?" + query;
        } 

        const dataSource = this.dataCoreService.getOData(tableName);

        const filterArr:any[] = [];

        if (this.service.controlCondition) {
            this.service.controlCondition.forEach((item: any) => {
                filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
            });
        }

        dataSource.select([]);
        if (filterArr.length > 0) dataSource.filter(filterArr);
        return dataSource;



    }
}
